// extracted by mini-css-extract-plugin
module.exports = {"cardNoPadding":"DocumentManagerTabItem_cardNoPadding__2vASu","searchBarContainer":"DocumentManagerTabItem_searchBarContainer__37COD"};